import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3c0cab1e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=3c0cab1e&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=3c0cab1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0cab1e",
  null
  
)

export default component.exports